import { render, staticRenderFns } from "./AddACL.vue?vue&type=template&id=1abfcb7b&scoped=true&"
import script from "./AddACL.vue?vue&type=script&lang=js&"
export * from "./AddACL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abfcb7b",
  null
  
)

export default component.exports